import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGapIncomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle cx={12} cy={12} r={9} fill="#999" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m10 14.78-2.313-2.313a.664.664 0 1 0-.94.94l2.786 2.786c.26.26.68.26.94 0l7.054-7.053a.664.664 0 1 0-.94-.94z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGapIncomeIcon;
